/* eslint-disable radix */
/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */

import {
  Box,
  Text,
  Flex,
  Button,
  Stack,
  Textarea,
  useBreakpointValue
} from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { SubmitHandler, useForm } from 'react-hook-form'

import { useTranslation } from 'react-i18next'

import { CardContainer } from '../../components/molecules/CardContainer'
import { Input } from '../../components/Form/Input'
import { Draft } from '../../components/molecules/Draft'
import { ArrowBack } from '../../components/atoms/arrowBack'
import { Sidebar } from '../../components/Sidebar'
import { Header } from '../../components/Header'

import { Switch } from '../../components/Form/Switch'
import { useAttendance } from './service'
import { SelectComponent } from '../../components/Form/SelectComponent'
import { PermissionComponent } from '../../components/Permissions'

type FormData = {
  is_active: boolean
  actions: string
  description: string
}

type Actions = {
  label: string
  value: string
}

export function UpdateDocumentsServices() {
  const [t] = useTranslation('pageDocumentsServices')
  const attendanceService = useAttendance()
  const { register, handleSubmit, formState } = useForm<FormData>({})
  const { errors } = formState
  const optionsDefaultActions = [
    {
      value: '1',
      label: `${t('actions.1')}`
    },
    {
      value: '2',
      label: `${t('actions.2')}`
    },
    {
      value: '3',
      label: `${t('actions.3')}`
    },
    {
      value: '4',
      label: `${t('actions.4')}`
    }
  ]
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  })
  // state
  const [name, setName] = useState('')
  const [actions, setActions] = useState<Actions>()
  const [valueDraft, setValueDraft] = useState<any>()
  const router = useHistory()
  const { state }: any = router.location

  useEffect(() => {
    if (state?.name !== undefined) {
      setName(state.name)
    }

    if (state?.document !== undefined) {
      if (state.document === 'undefined') {
        setValueDraft('')
      } else {
        setValueDraft(state.document)
      }
    }

    if (state?.actions !== undefined) {
      optionsDefaultActions.forEach((action) => {
        if (String(state.actions) === action.value) {
          setActions(action)
        }
      })
    }
  }, [])

  const handleSelectAction = (event: any) => {
    setActions(event)
  }

  const handleUpdateDocService: SubmitHandler<FormData> = async (values) => {
    await new Promise((resolve) => setTimeout(resolve, 2000))
    const { is_active, description } = values

    const payload = {
      id: state.id,
      name,
      is_active,
      document: valueDraft === undefined ? '<p><br><p>' : valueDraft,
      actions: actions?.value !== undefined ? actions.value : '1',
      description
    }

    attendanceService.updateAttendance(payload)
  }

  return (
    <Box overflow="hidden" position="relative">
      <Header>
        <Flex
          mx="auto"
          w="100%"
          direction="row"
          d="flex"
          my="6"
          align="center"
          justify="space-around"
        >
          <Box mx="auto">
            <Text fontSize="24px" fontWeight="600" height="100%">
              {t('updateTitle')}
            </Text>
          </Box>
          <Stack direction="row" align="center" justify="center">
            <ArrowBack href="/services/document-service">
              <Text fontSize="md" fontWeight="bold">
                Voltar
              </Text>
            </ArrowBack>
          </Stack>
        </Flex>
      </Header>
      <Sidebar />

      <Flex
        flex="1"
        mx="auto"
        as="form"
        ml={isWideVersion ? '75px' : '2'}
        mt="15px"
        mb="8px"
        mr="2"
        bg="white"
        h="cal(100vh - 60px)"
        onSubmit={handleSubmit(handleUpdateDocService)}
      >
        <Stack spacing="4" w="100%">
          <CardContainer title={t('create.container1.title')}>
            <Stack direction="row" my="2" spacing="6">
              <Box w="40%" mr="8">
                <Input
                  label={t('create.container1.i1')}
                  name="name"
                  value={name}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    setName(event.target.value.toUpperCase())
                  }
                  maxLength={30}
                />
              </Box>
              <Stack direction="row" my="2" spacing="8" w="50%">
                <Box w="300px" mr="2">
                  <SelectComponent
                    options={optionsDefaultActions}
                    name="actions"
                    value={actions}
                    onChange={handleSelectAction}
                    title={t('label.actions')}
                    placeholder={t('placeholder.actions')}
                  />
                </Box>
                <PermissionComponent
                  spiCode="SERVICES_DOCUMENTS"
                  ipCode="INACTIVATE"
                >
                  <Box ml="12">
                    <Switch
                      defaultChecked={state?.is_active === true}
                      label={t('create.container1.i2')}
                      {...register('is_active')}
                    />
                  </Box>
                </PermissionComponent>
              </Stack>
            </Stack>
          </CardContainer>

          <CardContainer title={t('create.container2.title')}>
            <Draft
              defaultValue={state?.document}
              getValue={(value: any) => {
                setValueDraft(value)
              }}
            />
          </CardContainer>

          <Flex mt="6" w="100%" align="flex-end" justifyContent="flex-end">
            <Button
              type="submit"
              size="md"
              fontSize="md"
              bg="blue.300"
              color="#fff"
              isLoading={formState.isSubmitting}
            >
              {t('create.button')}
            </Button>
          </Flex>
        </Stack>
      </Flex>
    </Box>
  )
}
